import { useMemo } from 'react'

/**
 * @param {Array<{ role?: string, agentQuestion?: import('./agentQuestionTypes.js').AgentQuestionPayload }>} messages
 * @returns {{ question: import('./agentQuestionTypes.js').AgentQuestionPayload, assistantMessageId: string } | null}
 */
export function useActiveAgentQuestion(messages) {
  return useMemo(() => {
    if (!messages?.length) return null
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      const msg = messages[i]
      if (msg?.role !== 'assistant') continue
      const q = msg.agentQuestion
      if (q?.status === 'open') {
        return { question: q, assistantMessageId: msg.id }
      }
    }
    return null
  }, [messages])
}
